import $ from 'jquery';

export default () => ({
    opened: false,
    scrolled: false,
    init() {
      const _this = this;
      this.scrolled = pageYOffset > this.$refs.main.clientHeight;
      window.addEventListener('scroll', () => this.scrolled = pageYOffset > this.$refs.main.clientHeight);
      
      $('a[href^="#"]').on('click', function(e) {
        _this.opened = false;
        e.preventDefault();
        let href = $(this).attr('href'),
            $el = $(href);
    
        if ($el.length) {
          console.log($('#main-nav')[0].clientHeight);
          $('html, body').animate({
              scrollTop: $el.offset().top
          }, 500);
        } else {
          location.href = '/' + href;
        }
      });
    },
    goBack() {
      location.href = "/gallery";
    }
})